export default {
  title: "Select Model of Item",
  confirm_part1: "Confirm that you want to register",
  confirm_part2: 'as the <b class="text-info">Model</b> of the <b class="text-info">Item</b>',
  hint: "<b>Hint:</b> Long-press on a Model in the list to see its Overview screen if you need more details before choosing.",
}
